import React from "react"

import { Button } from "@/components/ui/Button"

import questionIcon from "../../../assets/images/order/question.png"

interface HelpBannerProps {
  title: string
  description: string
  buttonText: string
  onButtonClick: () => void
}

export function HelpBanner({
  title,
  description,
  buttonText,
  onButtonClick,
}: HelpBannerProps) {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-p-6 tw-bg-gray-50 tw-rounded-xl tw-shadow-md tw-mt-10 tw-border-gray-200 tw-border-2">
      <div className="tw-flex tw-items-center tw-gap-5">
        <img
          className="tw-mr-1 tw-mt-1.5 tw-h-10"
          src={questionIcon}
          alt="Question"
        />
        <div>
          <div className="tw-text-base tw-font-semibold tw-text-gray-900 tw-mb-1">
            {title}
          </div>
          <div className="tw-text-sm tw-text-gray-700">{description}</div>
        </div>
      </div>

      <Button
        className="tw-w-1/4 tw-py-4 tw-text-center tw-text-sm tw-font-semibold tw-border tw-border-gray-200 tw-rounded-[2px] tw-bg-white tw-text-gray-800 tw-transition-colors tw-duration-300 tw-hover:bg-gray-50"
        variant="outline"
        size="lg"
        onClick={onButtonClick}
      >
        {buttonText}
      </Button>
    </div>
  )
}
